import React from 'react';
import { useSelector } from 'react-redux';
import ReceiptIcon from '@material-ui/icons/Receipt';
import {
  Table,
  TableContainer,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  IconButton,
} from '@material-ui/core';

import {
  getTerminalTableParamValue,
  sendTerminalReport,
  getTerminalState,
} from 'functions/kassa24';

const tableHead = [
  'Номер терминала',
  'Имя',
  'Адрес',
  'Агент',
  'Последний платеж',
  'Последний пинг',
  'Информация',
  '',
];
let headKey = 0;

const TerminalsTable = () => {
  const userInfo = useSelector((state) => state.user.userInfo || {});
  const terminals = useSelector((state) => state.main.terminals);

  //отправить сообщение технику о проблемах с терминалом
  const sendReport = (id) => {
    sendTerminalReport({ userInfo, id });
  };

  return (
    <>
      {terminals && terminals.length > 0 ? (
        <div>
          <h3>Терминалы</h3>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {tableHead.map((item) => (
                    <TableCell key={headKey++}>{item}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {terminals.map(
                  ({
                    d_ping,
                    id_terminal,
                    name,
                    hour_work,
                    agent_name,
                    address,
                    last_pay,
                    errors,
                    terminal_type,
                    without_link,
                    active_point,
                    block_reason,
                    version_po,
                    fiscal_login,
                    fiscal_znm,
                    fiscal_idkkm,
                    fiscal_ofd_type,
                  }) => (
                    <TableRow
                      key={id_terminal}
                      className={
                        getTerminalState(d_ping?.String) ? 'styleErrBackgr' : ''
                      }
                    >
                      <TableCell>{id_terminal}</TableCell>
                      <TableCell>{name}</TableCell>
                      <TableCell>
                        {getTerminalTableParamValue('hourwork', {
                          HourWork: hour_work,
                        })}
                      </TableCell>
                      <TableCell>
                        <p>{agent_name}</p>
                        <p>{address?.String}</p>
                      </TableCell>
                      <TableCell>
                        {last_pay.substring(0, 10)}
                        &nbsp;
                        {last_pay.substring(11, 19)}
                      </TableCell>
                      <TableCell>
                        {getTerminalTableParamValue('dping', {
                          DPing: d_ping,
                          WithoutLink: without_link,
                        })}
                      </TableCell>
                      <TableCell>
                        <p>
                          Статус:
                          {getTerminalTableParamValue('status', {
                            ActivePoint: active_point,
                            BlockReason: block_reason,
                          })}
                        </p>
                        {errors?.map((err) => (
                          <p key={err.code}>
                            {err.type}:{' '}
                            <b
                              className={
                                Number(err.code) === 0
                                  ? 'styleSuctext'
                                  : 'styleErr'
                              }
                            >
                              {err.text}
                            </b>
                          </p>
                        ))}
                        <p>
                          Тип терминала:{' '}
                          <b>
                            {getTerminalTableParamValue('terminalType', {
                              TerminalType: terminal_type,
                            })}
                          </b>
                        </p>
                        <p>
                          Версия ПО:{' '}
                          <b>
                            {getTerminalTableParamValue('poVersion', {
                              VersionPo: version_po,
                            })}
                          </b>
                        </p>
                        <p>
                          Логин в фискале:{' '}
                          <b>
                            {getTerminalTableParamValue('fiscalLogin', {
                              fiscal_login,
                            })}
                          </b>
                        </p>
                        <p>
                          ЗНМ в фискале:{' '}
                          <b>
                            {getTerminalTableParamValue('fiscalZnm', {
                              fiscal_znm,
                            })}
                          </b>
                        </p>
                        <p>
                          ID KKM в фискале:{' '}
                          <b>
                            {getTerminalTableParamValue('fiscalIdKkm', {
                              fiscal_idkkm,
                            })}
                          </b>
                        </p>
                        <p>
                          Провайдер ОФД:{' '}
                          <b>{fiscal_ofd_type || 'Не указано'}</b>
                        </p>
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => sendReport(id_terminal)}>
                          <ReceiptIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <>По заданным параметрам терминалов не найдено</>
      )}
    </>
  );
};

export default TerminalsTable;
